import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import FullLanguages from './FullLanguages';

export const GET_LANGUAGES = gql`
        {
            languages {
                id,
                name
            }
        }
    `;

export function parseGql({ data }) {
    if (data.loading || data.error) return { languages: [] };

    const languages = data.languages.map(x => ({
        id: x.id,
        name: x.name.toLowerCase(),
    }));

    return {
        languages,
    };
}

export function gqlSkipCondition() { return false; }

const withLanguages = graphql(GET_LANGUAGES, {
    skip: gqlSkipCondition,
    props: parseGql,
});

export default withLanguages(FullLanguages);
